import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
console.log('API_URL from environment:', API_URL); // Debug log
if (!API_URL) {
  console.error('REACT_APP_API_URL is not set!');
  throw new Error('REACT_APP_API_URL environment variable is required. Please set it in your environment variables.');
}
console.log('Using API URL:', API_URL); // Debug log

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true
});

// To handle requests with authentication
export const apiWithAuth = (token) => {
  if (!token) {
    console.error('No token provided to apiWithAuth');
    throw new Error('No token provided to apiWithAuth');
  }
  
  // If token already includes 'Bearer', use it as is
  if (token.startsWith('Bearer ')) {
    return axios.create({
      baseURL: API_URL,
      headers: {
        "Authorization": token,
        "Content-Type": "application/json"
      },
      withCredentials: true
    });
  }
  
  // Otherwise, add 'Bearer' prefix
  return axios.create({
    baseURL: API_URL,
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    withCredentials: true
  });
};
